import clsx from "clsx";
import type { HTMLAttributes } from "react";
import React from "react";
import type { TabProps } from "./Tab";
import styles from "./tabs.module.scss";

type TId = string | number;

export type TabsProps = {
  activeTabId: TId;
  onChange: (id: TId) => void;
  children: React.ReactElement<TabProps<React.ReactNode>>[];
} & Omit<HTMLAttributes<HTMLDivElement>, "children">;

const Tabs = (props: TabsProps) => {
  const { children, className, activeTabId, onChange, ...rest } = props;
  return (
    <div {...rest} className={clsx(styles["tabs"], className)}>
      {children?.map((child, i) => {
        const id = child?.props.id || i + 1;
        return (
          child &&
          React.cloneElement(child, {
            id,
            isActive: activeTabId === id,
            onClick: (e) => {
              child?.props.onClick && child?.props?.onClick(e);
              onChange(id);
            }
          })
        );
      })}
    </div>
  );
};

export default Tabs;
export { default as Tab } from "./Tab";
export * from "./Tab";
